import {
  post_request,
  get_request_export
} from '../axiosFun'
//查询维保日志列表
export const get_repair_maintenance_list = (params) => {
  params = {
    row: {
      vin: params.vin,
      fault_level_id: params.fault_level_id,
      fault_type_id: params.fault_type_id,
      maintenance_time: params.maintenance_time_str,
      page_no: params.page,
      page_size: params.limit
    }
  }
  return post_request("/web/repair_maintenance/list", params)
}
//添加维保日志
export const get_repair_maintenance_add = (params) => {
  params = {
    row: {
      vin: params.vin,
      maintenance_man: params.maintenance_man,
      phone: params.phone,
      fault_level_id: params.fault_level_id,
      fault_type_id: params.fault_type_id,
      maintenance_time: params.maintenance_time_str,
      fault_description: params.fault_description,
      fault_solution_description: params.fault_solution_description
    }
  }
  return post_request("/web/repair_maintenance/add", params)
}
//获取单条维保日志
export const get_repair_maintenance_one = (params) => {
  params = {
    row: {
      id:params
    }
  }
  return post_request("/web/repair_maintenance/get_one", params)
}
//编辑维保日志
export const get_repair_maintenance_edit = (params) => {
  params = {
    row: {
      id:params.id,
      vin: params.vin,
      maintenance_man: params.maintenance_man,
      phone: params.phone,
      fault_level_id: params.fault_level_id,
      fault_type_id: params.fault_type_id,
      maintenance_time: params.maintenance_time_str,
      fault_description: params.fault_description,
      fault_solution_description: params.fault_solution_description
    }
  }
  return post_request("/web/repair_maintenance/update", params)
}
//删除维保日志
export const get_repair_maintenance_del = (params) => {
  params = {
    row: {
      id:params
    }
  }
  return post_request("/web/repair_maintenance/delete", params)
}
//查询故障等级列表
export const get_fault_level_list = (params) => {
  params = {
    row: {
    }
  }
  return post_request("/web/repair_maintenance/fault_level", params)
}
//查询故障类型列表

export const get_fault_type_list = (params) => {
  params = {
    row: {
    }
  }
  return post_request("/web/repair_maintenance/fault_type", params)
}
//查询车辆列表
export const get_vin_list = (params) => {
  params = {
    row: {

    }
  }
  return post_request("/web/projectAccidentLog/get_vins", params)
}
//导出维保日志
export const get_export_repairLog = (params) => {
  params = {
    row: {
      ids: params
    }
  }
  return get_request_export("/web/repair_maintenance/export_selected", params)
}


// WEBPACK FOOTER //
// ./src/api/projectLog/repairLog.js